
import wx from 'weixin-js-sdk'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'


export default {
name: 'addLostCode',
components: {
wx,XTextarea,Group,Datetime
},
data() {
return {
datetimeStatus:false,
startDate:'',
filePath: [],
formData:{
id:0,
pics:[],
content:'',
lost_time:'',
},
}
},
created() {
this.setDate();
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.getLostClothes();
}
this.config();
},
computed:{

},
methods: {
setDate() {
var nowDate = new Date();
var date = {
year: nowDate.getFullYear(),
month: nowDate.getMonth() + 1,
day: nowDate.getDate(),

}
this.formData.lost_time = date.year + '-' + (date.month >= 10 ? date.month : '0' + date.month) + '-' + (date.day >= 10 ? date.day : '0' + date.day);
},
datetimeChange(val){
this.formData.lost_time = val;
this.datetimeStatus = false;
},
getLostClothes() {

this.$api.getLostClothes({id:this.formData.id}).then((res)=>{
if(res){
this.formData.pics = res.data.pics;
this.filePath = res.data.pics_path;
this.formData.lost_time = res.data.lost_time;
this.formData.content = res.data.content;
this.formData.id = res.data.id;
}
})

},
submit() {
if(!this.formData.pics || !this.formData.pics.length){
this.$func.showToast('请上传衣物图片');
return false;
}
this.$api.submitLostClothes(this.formData).then((res)=>{
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
});
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false, //调试阶段建议开启
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"chooseImage",
"uploadImage",
]
});
}
})
},
uploadFile(){
let that = this;
wx.chooseImage({
count: 9,
sizeType: ['original', 'compressed'],
sourceType: ['album', 'camera'],
success: function (res) {
that.uploadImg(res.localIds);
}
});
},
uploadImg(localIds){
let localId = localIds.pop();
let that = this;
wx.uploadImage({
localId: localId,
success: function (res) {
that.$api.uploadsImg({serverId:res.serverId}).then((res)=>{
if(res){
that.filePath.push(res.data.url);
that.formData.pics.push(res.data.path);
if(localIds.length > 0){
that.uploadImg(localIds);
}
}
})
}
});
},
showPic(index) {
wx.previewImage({
current: this.filePath[index], // 当前显示图片的http链接
urls: this.filePath 
});
},
delImg(index){
this.filePath.splice(index,1);
this.formData.pics.splice(index,1);
}
}
}



// WEBPACK FOOTER //
// ./src/pages/addLostCode.vue